module.exports = __webpack_public_path__ + "img/login.3eb3ad67.png";